import { useCallback } from "react";
import { getEmployeeList } from "src/apis/employeeApi";
import { MST4030_R01DetailDto } from "../Dto_MST4030_R01";

interface UseMST4030_R01CellChangeProps {
	updateMST4030_R01DetailList: (index: number, data: MST4030_R01DetailDto) => void;
	settingCodeSearchModalProps: (
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		rowData: MST4030_R01DetailDto,
		valueIndex: number,
		originalData?: MST4030_R01DetailDto,
	) => void;
}

export function useMST4030_R01CellChange({
	updateMST4030_R01DetailList,
	settingCodeSearchModalProps,
}: UseMST4030_R01CellChangeProps) {
	const handleInspectEmpnoSearch = useCallback(
		async (inspectEmpno: string, rowData: MST4030_R01DetailDto, oldValue?: string) => {
			if (!inspectEmpno?.trim()) {
				updateMST4030_R01DetailList(rowData.valueIndex, {
					...rowData,
					inspectEmpno: "",
					inspectEmpNm: "",
					isModified: true,
				});
				return;
			}

			const originalData = {
				...rowData,
				inspectEmpno: oldValue || rowData.inspectEmpno,
				inspectEmpNm: rowData.inspectEmpNm,
			};

			try {
				const response = await getEmployeeList(inspectEmpno);
				const foundEmployee = response.data.data.find((employee: any) => employee.empNo === inspectEmpno);

				if (foundEmployee) {
					updateMST4030_R01DetailList(rowData.valueIndex, {
						...rowData,
						inspectEmpno: foundEmployee.empNo || "",
						inspectEmpNm: foundEmployee.empNm || "",
						isModified: true,
					});
				} else {
					settingCodeSearchModalProps(
						"등록자",
						inspectEmpno,
						false,
						"inspectEmpno",
						rowData,
						rowData.valueIndex,
						originalData,
					);
				}
			} catch (error) {
				console.error("등록자명 검색 오류:", error);
				updateMST4030_R01DetailList(rowData.valueIndex, originalData);
				settingCodeSearchModalProps(
					"등록자",
					inspectEmpno || "all",
					false,
					"inspectEmpno",
					rowData,
					rowData.valueIndex,
					originalData,
				);
			}
		},
		[updateMST4030_R01DetailList, settingCodeSearchModalProps],
	);

	const handleCellValueChanged = useCallback(
		(e: any) => {
			const rowData = e.data as MST4030_R01DetailDto;
			if (!rowData || !rowData.valueIndex) return;

			const { colDef, newValue, oldValue } = e;
			const field = colDef?.field as keyof MST4030_R01DetailDto;

			if (field === "inspectEmpno" && newValue !== oldValue) {
				handleInspectEmpnoSearch(newValue, rowData, oldValue);
				return;
			}

			updateMST4030_R01DetailList(rowData.valueIndex, {
				...rowData,
				isModified: true,
			});
		},
		[updateMST4030_R01DetailList, handleInspectEmpnoSearch],
	);

	return { handleCellValueChanged };
}
